// extracted by mini-css-extract-plugin
export default {"st0":"fouBnO4TuN7","icon":"fouEEsp4UE3"};